import { useQuery } from 'react-query'
import axios from "axios";
import { setHeaders } from '../../../utils/basic';
import * as config from "../../../app.config";

const getDisplayData = async () => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/display/documentation/qlp_metrics/`,
        {
            headers: headerConfig
        }
    );
    return data?.data;
}

export const useFetchQlpMetricsDocs = () => {
    return useQuery(['qlpMetricsDocs'], getDisplayData, {
        onSuccess: data => {
            console.log("success");
        },
        onError: error => {
            console.log({ error });
        }
    });
}

